import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import axios from 'axios';
import {
  Select,
  Input,
  DatePicker,
  Row,
  Col,
  Tabs,
  Spin,
  message,
  Checkbox,
} from 'antd';
import { Typography } from 'antd';
import {
  getJiraUsers,
  getJiraIssuePicker,
  getJiraIssueLinkBlocks,
  getTaskAssignableUsers,
  getJiraBoardSprint,
} from '../skills_action';
import { getEpics } from '../skill_builder/skillBuilderActions';
import moment from 'moment';
import _ from 'lodash';

const { Text } = Typography;
const { Option } = Select;
const { TextArea } = Input;
const { TabPane } = Tabs;

class GetIssueField extends Component {
  constructor(props) {
    super(props);
    this.state = {
      jiraUsers: [],
      assignableUsers: [],
      autoCompleteData: {},
      selectedIssueTab: '',
      allIssueTypeFields: [],
      fields: [],
      fieldLoading: {},
      hiddenFields: {},
    };
  }

  componentDidMount() {}

  componentDidUpdate(prevProps, prevState) {}

  getHeader = ({ field }) => {
    return (
      <>
        <Text type='secondary' strong>
          {field.name}
        </Text>
        <br />
      </>
    );
  };

  getSelect = ({ field }) => {
    const { initialValue } = this.props;
    const { autoCompleteData, fieldLoading } = this.state;
    const { boardSprints } = this.props;
    const schemaType = field.schema.type;
    const showSearch =
      field.schema.custom === 'com.pyxis.greenhopper.jira:gh-sprint'
        ? false
        : true;
    const allowedValues = field.allowedValues || false;
    const autoCompleteUrl = field.autoCompleteUrl || false;
    let isIssueSelect = false,
      isEpicIssueSelect = false,
      isSprintSelect = false;

    isEpicIssueSelect =
      field.schema.custom === 'com.pyxis.greenhopper.jira:gh-epic-link' ||
      field.key === 'parent'
        ? true
        : false;
    isSprintSelect =
      field.schema.custom === 'com.pyxis.greenhopper.jira:gh-sprint'
        ? true
        : false;

    const isMultiSelect =
      schemaType === 'priority' ||
      schemaType === 'user' ||
      // field.schema.items === 'user' ||
      schemaType === 'option' ||
      schemaType === 'option2' ||
      schemaType === 'resolution' ||
      schemaType === 'issuelink' ||
      field.schema.items === 'issuelinks' ||
      isEpicIssueSelect ||
      isSprintSelect
        ? false
        : true;

    const getOptions = () => {
      if (allowedValues) {
        return (
          <>
            {allowedValues.map((value) => {
              if (value && value.disabled) {
                return null;
              }
              return (
                <Option key={value.id} value={value.id}>
                  {value.name || value.label || value.value || ''}
                </Option>
              );
            })}
          </>
        );
      } else if (schemaType === 'user' || field.schema.items === 'user') {
        return (
          <>
            {field.key === 'assignee' && this.props.forEmojiAction && (
              <Option
                key={'assign_to_action_taker'}
                value={'assign_to_action_taker'}
              >
                Assign to action taker
              </Option>
            )}
            {this.state[
              field.key === 'assignee' ? 'assignableUsers' : 'jiraUsers'
            ].map((user) => {
              return (
                <Option
                  key={user.accountId || user.key}
                  keyData={
                    user.accountId || user.name
                  } /* id={user.accountId || user.key} displayName={user.displayName || ''} */
                >
                  {user.displayName}
                </Option>
              );
            })}
          </>
        );
      } else if (
        autoCompleteUrl ||
        field.key === 'parent' ||
        isEpicIssueSelect
      ) {
        // console.log(autoCompleteData[field.key]);
        let valueName, key;
        if (field.key === 'labels') {
          valueName = 'label';
          key = 'label';
        } else if (
          field.key === 'issuelinks' ||
          field.key === 'parent' ||
          isEpicIssueSelect
        ) {
          valueName = 'key';
          key = 'key';
          isIssueSelect = true;
        } else if (
          field.schema.custom ===
          'com.atlassian.jira.plugin.system.customfieldtypes:labels'
        ) {
          valueName = 'label';
          key = 'label';
        } else {
          valueName = 'value';
          key = 'id';
        }
        if (autoCompleteData[field.key] || isEpicIssueSelect) {
          const data = isEpicIssueSelect
            ? this.props.epics
            : autoCompleteData[field.key];
          return (
            <>
              {data.map((value) => {
                return (
                  <Option key={value[key]} value={value[key]}>
                    {isIssueSelect
                      ? '(' +
                        value.key +
                        ') ' +
                        (isEpicIssueSelect
                          ? value.fields && value.fields.summary
                          : value.summaryText)
                      : value[valueName]}
                    {/* {isIssueSelect ? "(" + value.key + ") " + 'some data' :''} */}
                  </Option>
                );
              })}
            </>
          );
        }
      } else if (isSprintSelect) {
        const activeSprints = boardSprints.filter(
          (sprint) => sprint.state === 'active'
        );
        const futureSprints = boardSprints.filter(
          (sprint) => sprint.state === 'future'
        );
        return (
          <>
            {activeSprints.length > 0 && (
              <Select.OptGroup label='Active Sprints'>
                {activeSprints.map((sprint) => {
                  return <Option key={sprint.id}>{sprint.name}</Option>;
                })}
              </Select.OptGroup>
            )}
            {futureSprints.length > 0 && (
              <Select.OptGroup label='Future Sprints'>
                {futureSprints.map((sprint) => {
                  return <Option key={sprint.id}>{sprint.name}</Option>;
                })}
              </Select.OptGroup>
            )}
            {
              <Select.OptGroup label='Other'>
                <Option
                  value='choose_current_sprint'
                  key='choose_current_sprint'
                >
                  Current (first active sprint)
                </Option>
                ;
              </Select.OptGroup>
            }
          </>
        );
      }
    };

    const onSearchChange = (value) => {
      if (schemaType === 'user' || field.schema.items === 'user') {
        if (field.key === 'assignee') this.getAssignableUsers(value, field);
        else this.getJiraUsersData(value, field);
      } else if (autoCompleteUrl)
        this.getJiraAutoCompletionData({ field, query: value });
      else if (isEpicIssueSelect) this.getEpicIssues({ field, query: value });
    };

    const onFocus = () => {
      if (schemaType === 'user' || field.schema.items === 'user') {
        if (field.key === 'assignee') this.getAssignableUsers('', field);
        else this.getJiraUsersData('', field);
      } else if (autoCompleteUrl) this.getJiraAutoCompletionData({ field });
      else if (isEpicIssueSelect) this.getEpicIssues({ field, query: '' });
      else if (isSprintSelect && this.props.board)
        this.props.getJiraBoardSprint(
          this.props.match.params.wId,
          this.props.board
        );
    };

    const isUserInOptions = (id) => {
      const user = this.state[
        field.key === 'assignee' ? 'assignableUsers' : 'jiraUsers'
      ].find((user) => user.accountId === id || user.key === id);
      return user ? true : false;
    };

    let valueData;

    if (schemaType === 'user' || field.schema.items === 'user') {
      if (initialValue) {
        if (schemaType === 'user') {
          const data = initialValue;
          valueData =
            data &&
            data.key &&
            data[isUserInOptions(data.key) ? 'key' : 'children'];
        } else {
          valueData = [];
          initialValue.forEach((user) => {
            valueData.push(
              user[isUserInOptions(user.key) ? 'key' : 'children']
            );
          });
        }
      }
    } else if (isSprintSelect) {
      if (initialValue) {
        const data = initialValue;
        if (data === 'choose_current_sprint') {
          valueData = 'choose_current_sprint';
        } else {
          const sprintFount = boardSprints.find(
            (sprint) => sprint.id === data.id
          );
          if (sprintFount) valueData = data.id.toString();
          else valueData = data.name;
        }
      }
    } else {
      valueData = initialValue;
    }

    return (
      <>
        {!this.props.forChannelSync && this.getHeader({ field })}
        <Select
          placeholder={this.getPlaceHolderText(field)}
          style={{ width: '100%', marginBottom: '15px' }}
          onFocus={onFocus}
          onSearch={onSearchChange}
          showSearch={showSearch}
          filterOption={(input, option) =>
            option.props.children.toLowerCase().indexOf(input.toLowerCase()) >=
            0
          }
          mode={isMultiSelect ? 'multiple' : ''}
          value={valueData}
          onChange={(value, optionData) => {
            this.setFieldDefaults({ value, optionData, field, isSprintSelect });
          }}
          allowClear
          notFoundContent={
            fieldLoading[field.key] ? <Spin size='small' /> : null
          }
          loading={fieldLoading[field.key]}
          disabled={this.props.disableEdit}
        >
          {getOptions()}
          {/* <Option>111</Option> */}
        </Select>
        <br />
      </>
    );
  };

  getIssueLinkSelects = ({ field }) => {
    let { initialValue } = this.props;
    const { autoCompleteData, selectedIssueTab } = this.state;
    const key = field.key;
    let validOptions = [];
    const getOptions = () => {
      if (autoCompleteData[key] && autoCompleteData[key].issueLinkTypes) {
        autoCompleteData[key].issueLinkTypes.forEach((linkType) => {
          validOptions.push({
            id: `inward_${linkType.id}`,
            value: linkType.inward,
          });

          if (linkType.inward !== linkType.outward)
            validOptions.push({
              id: `outward_${linkType.id}`,
              value: linkType.outward,
            });
        });
        return validOptions.map((data) => {
          return (
            <Option key={data.id} value={data.id}>
              {data.value}
            </Option>
          );
        });
      }
    };

    const getIssueOptions = () => {
      if (autoCompleteData[key] && autoCompleteData[key].issues) {
        return autoCompleteData[key].issues.map((issue) => {
          return (
            <Option
              key={issue.key}
              value={issue.key}
            >{`(${issue.key}) ${issue.summaryText}`}</Option>
          );
        });
      }
    };

    const onFocus = () => {
      this.getJiraAutoCompletionData({ field, getIssueLinkBlocks: true });
    };

    const onIssueFieldFocus = () => {
      this.getJiraAutoCompletionData({ field });
    };

    const onIssueSearch = (value) => {
      this.getJiraAutoCompletionData({ field, query: value });
    };

    const onChange = (value, type) => {
      if (!initialValue) initialValue = {};
      if (type === 'issueLink') {
        const linkTypeFound = validOptions.find((data) => data.id === value);
        initialValue.linkType = linkTypeFound || {};
      } else if (type === 'issue') initialValue.issue = value;
      this.setFieldDefaults({ value: initialValue, field, type });
    };

    return (
      <>
        <Text type='secondary' strong>
          Issue Link Type
        </Text>
        <br />
        <Select
          placeholder='Select link type'
          style={{ width: '100%', marginBottom: '15px' }}
          onFocus={onFocus}
          // onSearch={onSearchChange}
          // showSearch={showSearch}
          // mode={isMultiSelect ? "multiple" : ""}
          value={
            initialValue && initialValue.linkType && initialValue.linkType.value
          }
          onChange={(value) => onChange(value, 'issueLink')}
          allowClear
          disabled={this.props.disableEdit}
        >
          {getOptions()}
        </Select>
        <br />
        {!this.props.forChannelSync && this.getHeader({ field })}
        <Select
          placeholder='Type key or summary'
          style={{ width: '100%', marginBottom: '15px' }}
          showSearch
          onFocus={onIssueFieldFocus}
          onSearch={onIssueSearch}
          onChange={(value) => onChange(value, 'issue')}
          value={initialValue && initialValue.issue}
          allowClear
          notFoundContent={
            this.state.fieldLoading[field.key] ? <Spin type='small' /> : null
          }
          loading={this.state.fieldLoading[field.key]}
          disabled={this.props.disableEdit}
        >
          {getIssueOptions()}
        </Select>
      </>
    );
  };

  // getSprintSelects = ({ field }) => {
  //   const { jiraBoards, boardSprints } = this.props;

  //   const boardOptions = () => {
  //     console.log(jiraBoards);
  //     return jiraBoards.map((board) => {
  //       return <Option key={board.id}>{board.name}</Option>;
  //     });
  //   };
  //   // const onSprintFocus = () => {
  //   //   this.props.getJiraBoardSprint()
  //   // }

  //   return (
  //     <>
  //       {this.getHeader({ field })}
  //       <Row gutter={[16, 16]}>
  //         <Col span={12}>
  //           <Select onFocus={this.onBoardFocus} style={{ width: "100%", marginBottom: "15px" }}></Select>
  //         </Col>
  //         <Col span={12}>
  //           <Select
  //             // onFocus={onSprintFocus}
  //             style={{ width: "100%", marginBottom: "15px" }}
  //           >
  //             {boardOptions()}
  //           </Select>
  //         </Col>
  //       </Row>
  //     </>
  //   );
  // };

  getSelectCasecading = ({ field }) => {
    const { initialValue } = this.props;
    const { selectedIssueTab } = this.state;

    const schemaType = field.schema.type;
    const showSearch = true;
    const allowedValues = field.allowedValues || false;

    const getOptionsFirstSelect = () => {
      if (allowedValues) {
        return (
          <>
            {allowedValues.map((value) => {
              if (value && value.disabled) {
                return null;
              }
              return (
                <Option key={value.id} value={value.id}>
                  {value.value}
                </Option>
              );
            })}
          </>
        );
      }
    };

    const getOptionsSecondSelect = () => {
      if (allowedValues) {
        const fieldData = initialValue;
        const secondSelectAllowedValuesData = fieldData
          ? allowedValues.find(
              (value) => value.id === fieldData.firstSelectValue
            )
          : false;
        if (secondSelectAllowedValuesData)
          return (
            <>
              {secondSelectAllowedValuesData.children &&
                secondSelectAllowedValuesData.children.map((value) => {
                  return (
                    <Option key={value.id} value={value.id}>
                      {value.value}
                    </Option>
                  );
                })}
            </>
          );
      }
    };

    return (
      <>
        {!this.props.forChannelSync && this.getHeader({ field })}
        <Row gutter={[16, 16]}>
          <Col span={12}>
            <Select
              placeholder={`Choose ${field.name}`}
              style={{ width: '100%', marginBottom: '15px' }}
              value={initialValue && initialValue.firstSelectValue}
              allowClear
              onChange={(value) =>
                this.setFieldDefaults({
                  value,
                  field,
                  cascadeSelect: { firstSelectValue: value },
                })
              }
              showSearch={showSearch}
              disabled={this.props.disableEdit}
            >
              {getOptionsFirstSelect()}
            </Select>
          </Col>
          <Col span={12}>
            <Select
              placeholder={'Select a option'}
              style={{ width: '100%', marginBottom: '15px' }}
              allowClear
              disabled={
                this.props.disableEdit
                  ? true
                  : initialValue && initialValue.firstSelectValue
                  ? false
                  : true
              }
              value={initialValue && initialValue.secondSelectValue}
              onChange={(value) =>
                this.setFieldDefaults({
                  value,
                  field,
                  cascadeSelect: { secondSelectValue: value },
                })
              }
              showSearch={showSearch}
            >
              {getOptionsSecondSelect()}
            </Select>
          </Col>
          <br />
        </Row>
      </>
    );
  };

  getInput = ({ field }) => {
    const { initialValue } = this.props;
    const schemaType = field.schema.type;
    let placeHolder = 'Enter something';
    if (schemaType === 'datetime') placeHolder = 'e.g 1996-10-15T23:05';
    return (
      <>
        {!this.props.forChannelSync && this.getHeader({ field })}
        <Input
          value={initialValue}
          onChange={(event) => {
            if (event.target.value && event.target.value.length > 255)
              message.error(`Only 255 characters are allowed in ${field.name}`);
            else this.setFieldDefaults({ value: event.target.value, field });
          }}
          placeholder={this.getPlaceHolderText(field)}
          style={{ width: '100%', marginBottom: '15px' }}
          allowClear
          disabled={this.props.disableEdit}
        ></Input>
        <br />
      </>
    );
  };

  getTimeTrackingInputs = ({ field }) => {
    const { initialValue } = this.props;

    const originalEstimateValue =
      (initialValue && initialValue.originalEstimate) || null;
    const remainingEstimateValue =
      (initialValue && initialValue.remainingEstimate) || null;
    return (
      <>
        <>
          <Text type='secondary' strong>
            Original Estimate
          </Text>
          <br />
        </>
        <Input
          style={{ width: '100%', marginBottom: '15px' }}
          placeholder='e.g 2w 4d 6h 45m'
          onChange={(event) =>
            this.setFieldDefaults({
              field,
              type: 'originalEstimate',
              value: event.target.value,
            })
          }
          value={originalEstimateValue}
          allowClear
          disabled={this.props.disableEdit}
        />
        <br />
        <>
          <Text type='secondary' strong>
            Remaining Estimate
          </Text>
          <br />
        </>
        <Input
          style={{ width: '100%', marginBottom: '15px' }}
          placeholder='e.g 2w 4d 6h 45m'
          onChange={(event) =>
            this.setFieldDefaults({
              field,
              type: 'remainingEstimate',
              value: event.target.value,
            })
          }
          value={remainingEstimateValue}
          allowClear
        />
        <br />
      </>
    );
  };

  getTextArea = ({ field }) => {
    const { initialValue } = this.props;
    return (
      <>
        {!this.props.forChannelSync && this.getHeader({ field })}
        <TextArea
          value={initialValue}
          onChange={(event) =>
            this.setFieldDefaults({ value: event.target.value, field })
          }
          placeholder={this.getPlaceHolderText(field)}
          style={{ width: '100%', marginBottom: '15px' }}
          allowClear
          disabled={this.props.disableEdit}
        ></TextArea>
        <br />
      </>
    );
  };

  // getInputNumber = ({ field }) => {
  //   const {fieldDefaults} = this.state
  //   return (
  //     <>
  //       {this.getHeader({ field })}
  //       <InputNumber value={fieldDefaults[field.key]} placeholder='Enter a number' style={{ width: "100%", marginBottom: "15px" }}></InputNumber>
  //       <br />
  //     </>
  //   );
  // };

  getDatePicker = ({ field }) => {
    const { initialValue } = this.props;
    return (
      <>
        {!this.props.forChannelSync && this.getHeader({ field })}
        <DatePicker
          value={initialValue && moment(initialValue)}
          allowClear
          onChange={(date, dateString) =>
            this.setFieldDefaults({ value: dateString, field })
          }
          style={{ width: '100%' }}
          disabled={this.props.disableEdit}
        />
        <br />
        <br />
      </>
    );
  };

  getJiraUsersData = (value, field) => {
    this.setLoadingState({ field, value: true });
    this.props
      .getJiraUsers(
        this.props.match.params.wId,
        this.props.skill_id,
        value || ''
      )
      .then((res) => {
        this.setLoadingState({ field, value: false });
        if (res.success) this.setState({ jiraUsers: res.users });
      });
  };

  getAssignableUsers = (value, field) => {
    const { projects, linkedProject } = this.props;
    const projectFound = projects.find(
      (project) => project.id === linkedProject
    );
    if (projectFound) {
      this.setLoadingState({ field, value: true });
      getTaskAssignableUsers(this.props.match.params.wId, {
        params: {
          query: value || '',
          project: projectFound.key,
        },
      }).then((res) => {
        this.setLoadingState({ field, value: false });
        if (res.data.success)
          this.setState({ assignableUsers: res.data.taskAssignableMemebers });
      });
    }
  };

  getEpicIssues = ({ field, query }) => {
    this.setLoadingState({ field, value: true });
    this.props
      .getEpics(
        this.props.match.params.wId,
        query || '',
        this.props.linkedProject
      )
      .then((res) => this.setLoadingState({ field, value: false }));
  };

  getJiraAutoCompletionData = ({ field, query, getIssueLinkBlocks }) => {
    this.setLoadingState({ field, value: true });
    if (
      (field.key === 'issuelinks' && !getIssueLinkBlocks) ||
      field.key === 'parent'
    ) {
      this.props
        .getJiraIssuePicker(this.props.match.params.wId, query || '')
        .then((res) => {
          this.setLoadingState({ field, value: false });
          if (res.data.success) {
            let autoCompleteData = { ...this.state.autoCompleteData };
            if (field.key === 'issuelinks') {
              if (!autoCompleteData[field.key])
                autoCompleteData[field.key] = {};
              autoCompleteData[field.key].issues = res.data.issues || [];
            } else {
              autoCompleteData[field.key] = res.data.issues || [];
            }
            this.setState({ autoCompleteData });
          }
        });
    } else if (field.schema.items === 'issuelinks' && getIssueLinkBlocks) {
      if (
        !this.state.autoCompleteData[field.key] ||
        (this.state.autoCompleteData[field.key] &&
          !this.state.autoCompleteData[field.key].issueLinkTypes)
      ) {
        this.props
          .getJiraIssueLinkBlocks(this.props.match.params.wId)
          .then((res) => {
            this.setLoadingState({ field, value: false });
            if (res.data.success) {
              let autoCompleteData = { ...this.state.autoCompleteData };
              if (!autoCompleteData[field.key])
                autoCompleteData[field.key] = {};
              autoCompleteData[field.key].issueLinkTypes =
                res.data.jiraIssueLinkBlocksData.issueLinkTypes;
              this.setState({ autoCompleteData });
            }
          });
      }
    } else {
      // let link = `/bot/skill/${(this.props.forEmojiAction || this.props.forCommands) ? this.props.skill_id : this.props.match.params.skill_id}/user/${this.props.user_now._id}/getJiraAutoCompleteOptions`;
      let link = `/bot/api/w/${this.props.match.params.wId}/skill/${this.props.skill_id}/user/${this.props.user_now._id}/getJiraAutoCompleteOptions`;
      axios
        .get(link, {
          params: {
            url: query ? field.autoCompleteUrl + query : field.autoCompleteUrl,
          },
        })
        .then((res) => {
          this.setLoadingState({ field, value: false });
          if (res.data.success) {
            let autoCompleteData = Object.assign(this.state.autoCompleteData);
            // if(field.key === 'issuelinks') autoCompleteData[field.key] = res.data.data.sections[0].issues
            // else
            autoCompleteData[field.key] = res.data.data.suggestions;
            this.setState({ autoCompleteData });
          }
        });
    }
  };

  getPlaceHolderText = (field) => {
    let placeholder = '';
    const type = field.schema.type;
    const name = field.name;
    if (field.schema.custom === 'com.pyxis.greenhopper.jira:gh-sprint')
      placeholder = 'Choose Sprint';
    else if (
      field.schema.custom === 'com.pyxis.greenhopper.jira:gh-epic-link' ||
      type === 'issuelink'
    )
      placeholder = 'Type Key or Summary';
    else if (type === 'number') placeholder = 'Enter a number';
    else if (type === 'issuetype') placeholder = `Select a ${name}`;
    else if (type === 'string' || type === 'comments-page')
      placeholder = `Write something`;
    else if (type === 'option' || type === 'option2')
      placeholder = `Choose ${name}`;
    else if (type === 'priority') placeholder = `Choose an priority`;
    else if (type === 'user') placeholder = `Start typing Jira username`;
    else if (type === 'date') placeholder = `Select a date`;
    else if (type === 'datetime') placeholder = `e.g 1996-10-15T23:05`;
    else if (type === 'resolution') placeholder = `Type resolution`;
    else if (type === 'resolution') placeholder = `Type resolution`;
    else if (type === 'array') {
      if (field.schema.items === 'group') placeholder = 'Format :- 1,2,3,4';
      else placeholder = `Choose ${name}`;
    }

    return placeholder;
  };

  getFields = (field) => {
    if (!field.key) {
      field.key = field.fieldId;
    }
    const isAllowedValueEmpty =
      field.allowedValues && field.allowedValues.length === 0 ? true : false;
    if (
      field.key !== 'issuetype' &&
      field.key !== 'attachment' &&
      field.key !== 'project' &&
      !(
        field.schema &&
        (field.schema.custom == 'com.pyxis.greenhopper.jira:gh-lexo-rank' ||
          field.schema.custom ==
            'com.atlassian.jira.plugins.jira-development-integration-plugin:devsummarycf')
      ) &&
      !isAllowedValueEmpty
    ) {
      const field_schema = field.schema;
      const schemaType = field.schema.type || '';
      const custom = field.schema.custom || '';

      if (
        field_schema.custom &&
        field_schema.custom === 'com.pyxis.greenhopper.jira:gh-sprint'
      ) {
        // return this.getSprintSelects({ field });
        return this.getSelect({ field });
      } else if (schemaType === 'number') {
        // return this.getInputNumber({ field });
        return this.getInput({ field });
      } else if (schemaType === 'string') {
        const customType = field_schema.custom
          ? field_schema.custom.split(':')[1]
          : '';
        const system = field_schema.system || '';
        if (
          customType == 'textarea' /* || system == "summary" */ ||
          system == 'environment' ||
          system == 'description'
        )
          return this.getTextArea({ field });
        else return this.getInput({ field });
      } else if (schemaType === 'issuetype') {
        return this.getSelect({ field });
      } else if (
        schemaType === 'array' ||
        schemaType === 'priority' ||
        field.schema.type === 'option' ||
        schemaType === 'option2'
      ) {
        if (field_schema.items === 'issuelinks') {
          return this.getIssueLinkSelects({ field });
        } else {
          if (field_schema.items === 'group') return this.getInput({ field });
          else return this.getSelect({ field });
        }
      } else if (schemaType === 'user') {
        return this.getSelect({ field });
      } else if (schemaType === 'date') {
        return this.getDatePicker({ field });
      } else if (schemaType === 'datetime') {
        return this.getInput({ field });
      } else if (custom === 'com.pyxis.greenhopper.jira:gh-epic-link') {
        return this.getSelect({ field });
        // } else if (custom === "com.atlassian.servicedesk:vp-origin") {
        //   return this.getSelect({ field });
      } else if (schemaType === 'comments-page') {
        return this.getInput({ field });
      } else if (schemaType === 'sd-request-lang') {
        return this.getInput({ field });
      } else if (schemaType === 'option-with-child') {
        return this.getSelectCasecading({ field });
      } else if (schemaType === 'resolution') {
        return this.getSelect({ field });
      } else if (schemaType === 'issuelink') {
        return this.getSelect({ field });
      } else if (schemaType === 'timetracking') {
        return this.getTimeTrackingInputs({ field });
      } else {
        console.warn('un handled field', field);
      }
    }
  };

  setLoadingState = ({ field, value }) => {
    let fieldLoading = { ...this.state.fieldLoading };
    fieldLoading[field.key] = value;
    this.setState({ fieldLoading });
  };

  setFieldDefaults = ({
    value,
    field,
    optionData,
    cascadeSelect,
    isSprintSelect,
    type,
  }) => {
    this.props.onFieldChange({
      value,
      field,
      optionData,
      cascadeSelect,
      isSprintSelect,
      type,
    });
  };

  render() {
    return <>{this.props.field && this.getFields(this.props.field)}</>;
  }
}

const mapStateToProps = (store) => {
  return {
    user_now: store.common_reducer.user,
    projects: store.skills.projects,
    epics: store.skill_builder.epics,
    jiraBoards: store.skills.jiraBoards,
    boardSprints: store.skills.jiraSprints,
  };
};

export default withRouter(
  connect(mapStateToProps, {
    getJiraUsers,
    getJiraIssuePicker,
    getJiraIssueLinkBlocks,
    getEpics,
    getJiraBoardSprint,
  })(GetIssueField)
);
